import BaseService from './base.service';

export default class OccupantVehicleService {
    static ENDPOINT = '/orgs';

    static async addVehicle(orgId, userId, payload) {
        const endpoint = `${this.ENDPOINT}/${orgId}/users/${userId}/vehicles`;
        return BaseService.post(endpoint, payload);
    }

    static async updateVehicle(orgId, userId, tag, payload) {
        const endpoint = `${this.ENDPOINT}/${orgId}/users/${userId}/vehicles/${encodeURIComponent(tag)}`;
        return BaseService.patch(endpoint, payload);
    }

    static async deleteVehicle(orgId, userId, tag) {
        const endpoint = `${this.ENDPOINT}/${orgId}/users/${userId}/vehicles/${encodeURIComponent(tag)}`;
        return BaseService.delete(endpoint);
    }
}
